import type { MetronomeSoundUrls } from "@/components/drumpattern/metronomeSampleLoader";

export const SYNTH_METRONOME_SOUND_ID = "synth";

export interface MetronomeSoundOption {
  id: string;
  name: string;
  accessTier: "free" | "premium";
  isDefault: boolean;
  locked: boolean;
}

export interface MetronomeSoundsResponse {
  sounds?: MetronomeSoundOption[];
  selectedSoundId?: string;
  urls?: MetronomeSoundUrls | null;
  error?: string;
}
